<div class="slider-container">
    <div class="popover-header">{{title}}</div>
    <ng-container *ngIf="optionsSet">
        <div class="custom-slider">
            <ngx-slider
                [(value)]="value"
                [options]="options"
                (userChangeStart)="onUserChangeStart($event)"
                (userChange)="onUserChange($event)"
                (userChangeEnd)="onUserChangeEnd($event)">
            </ngx-slider>
        </div>
    </ng-container>
    <!-- <div class="popover-footer">
        <button nbButton size="tiny" (click)="onSubmit()">Apply</button>
    </div> -->
</div>
